<template>
  <modal
    :open="modalIsOpen"
    @modal-abort="onAbort"
  >
    <template #title>
      {{ props.messages?.modals?.list_add?.title }}
    </template>
    <template #default>
      <form>
        <div class="form-group">
          <label
            for="name"
            data-required="required"
          >{{ props.messages?.modals?.list_add?.label_name }}</label>
          <input
            type="text"
            class="form-control"
            id="name"
            placeholder=""
            v-model="listName"
            required
          >
          <small
            v-if="formHasErrors && listNameEmpty"
            id="nameHelp"
            class="form-text text-muted"
          >{{ listNameError }}</small>
        </div>
        <div class="form-group">
          <label for="typeId">{{ props.messages?.modals?.list_add?.label_type }}</label>
          <input
            class="form-control"
            type="text"
            :placeholder="listTypeText"
            readonly
          >
        </div>
      </form>
    </template>
    <template #footer>
      <button
        type="button"
        class="btn btn-outline-default"
        data-dismiss="modal"
        @click="onClose"
      >
        {{
          props.messages?.modals?.list_add?.button_abort
        }}</button>
      <button
        type="button"
        class="btn btn-primary"
        @click="onSave"
      >
        {{ props.messages?.modals?.list_add?.button_save }}</button>
    </template>

  </modal>
</template>

<script setup lang="ts">
import { ref, Ref, computed, watch } from 'vue'

import Modal from '@/components/Modal/Modal.vue'

import { useIO } from '@/composables/io'

interface Props {
  open?: boolean
  messages: any
  urls: any
  bucket: any
  selectedValue: any
  typeId: string
}

const props = withDefaults(defineProps<Props>(), {
  open: false,
  messages: undefined,
  urls: undefined,
  bucket: undefined,
  selectedValue: undefined,
  typeId: undefined
})

const modalIsOpen = ref(props.open)

const listName = ref('')
const listNameEmpty = computed(() => listName.value.length === 0)
const listNameError: Ref<string> = ref(props.messages?.modals?.list_add?.error_name)

const listTypeId = ref(props.selectedValue?.type_id ? props.selectedValue?.type_id : props.typeId)
const listTypeText = computed(() => {
  const match = props.bucket.actionselect.list_types.filter(type => type.id === listTypeId.value)
  return match.length > 0 ? match[0].text : '--'
})

const formHasErrors = ref(false)

const resetForm = () => {
  listName.value = ''
  listTypeId.value = props.selectedValue?.type_id ? props.selectedValue?.type_id : props.typeId
  formHasErrors.value = false
}

watch(
  () => props.open,
  (n) => {
    modalIsOpen.value = n

    if (n) resetForm()
  }
)

const emit = defineEmits(['modal-close'])

const modalClose = (action = 'close', payload = {}) => {
  modalIsOpen.value = false
  emit('modal-close', { action: action, payload: payload })
}

const onAbort = () => {
  modalClose()
}

const onClose = () => {
  modalClose()
}

const onSave = async () => {
  if (listNameEmpty.value) {
    formHasErrors.value = true
    return
  }

  const { performFetchJson } = useIO()

  const data = {
    name: listName.value,
    typeId: listTypeId.value
  }

  const response = await performFetchJson(
    props.urls?.list_add,
    {
      method: 'POST',
      body: JSON.stringify({ values: data })
    }
  )

  modalClose('save', response)
}
</script>
